<template>
  <v-container
    :id="`journal-elastic-search-result-${journal.id}`"
    fluid
    class="journal-elastic-search-result pa-0 my-3"
  >
    <v-row
      no-gutters
      class="bg-white"
    >
      <v-col
        cols="12"
        class="px-2 d-flex justify-space-between"
      >
        <div>
          <span
            v-if="journal.departmentType == 'pediatrician'"
            class="department department--pediatrician"
          >
            小児科
          </span>
          <span
            v-else-if="journal.departmentType == 'obstetrician'"
            class="department department--obstetrician"
          >
            産婦人科
          </span>
          <span class="signature">
            ／ {{ journal.signature }}
          </span>
        </div>
        <v-btn
          class="d-flex align-center px-2 ma-0"
          variant="text"
          size="x-small"
          prepend-icon="mdi-link"
          @click="copyLink()"
        >
          コピー
        </v-btn>
      </v-col>
    </v-row>
    <v-row
      no-gutters
      class="bg-white"
    >
      <v-col
        cols="12"
        class="px-2"
      >
        <a
          :href="journal.link"
          target="_blank"
        >{{ journal.title }}</a>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
const props = defineProps({
  journal: {
    type: Object,
    required: true
  }
});

const copyLink = () => {
  const text = props.journal.title + "\n" + props.journal.link;
  document.addEventListener("copy", function(e) {
    e.clipboardData.setData("text/plain", text);
    e.preventDefault();
  },
  {once:true}
  );
  document.execCommand("copy");
};
</script>

<style lang="scss">
.journal-elastic-search-result {
  border-left: 3px solid rgba(0, 0, 0, 0.38);

  .header{
    font-size: small;
    color: #999;
  }
  .department {
    font-size: 12px;
  }
  .signature {
    font-size: 12px;
  }
}

</style>
